import React from 'react';
import { RequiredIosSafariPageLayout } from 'views/layouts/RequiredIphonePageLayout';
import { DefaultTemplate } from 'views/templates/DefaultTemplate';

export const RequiredIosSafariPage: React.FC = () => {
  return (
    <DefaultTemplate headerText="DeployGate" showLogo>
      <RequiredIosSafariPageLayout />
    </DefaultTemplate>
  );
};
